<template>
  <div class="comment__audit-compare-content">
    <BorderedTeam
      v-if="beforeTeamName"
      :src="beforeTeamPicture"
      :teamName="beforeTeamName"
      class="is-opacity"
    />
    <span
      v-else
      class="is-opacity"
      >None</span
    >
    <icon
      data="@icon/arrow-to.svg"
      :fill="true"
      width="var(--icon-24)"
      height="var(--icon-24)"
      color="var(--monochrome05to04)"
    />
    <BorderedTeam
      v-if="afterTeamName"
      :src="afterTeamPicture"
      :teamName="afterTeamName"
    />
    <span v-else>None</span>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue"

import BorderedTeam from "@/components/BorderedTeam/BorderedTeam.vue"

import { Comment } from "@/models"

const props = defineProps<{
  comment: Comment
}>()

const beforeTeamName = computed(() => props.comment.before?.teamName ?? null)
const beforeTeamPicture = computed(() => props.comment.before?.teamPictureUrl?.pictureUrl ?? null)
const afterTeamName = computed(() => props.comment.after?.teamName ?? null)
const afterTeamPicture = computed(() => props.comment.after?.teamPictureUrl?.pictureUrl ?? null)
</script>
